module.exports = __webpack_public_path__ + "static/media/cLogo.376d6ff9.png";